import { createAction, createSlice } from '@reduxjs/toolkit';

import {
  FieldValidationErrorPayload,
  PartnerProductCardsVisiblePayload,
  PartnerStorefrontLinkClickPayload,
} from '../tracking/events';
import { PartnerStorefrontState } from '../types';
import { contactPartnerSubmit } from './thunks';

export const initialState: PartnerStorefrontState = {
  messageSent: false,
  isContactPartnerModalOpen: false,
  error: null,
};

const { name, reducer, actions: reducerActions } = createSlice({
  name: 'partnerStorefront',
  initialState,
  reducers: {
    openContactPartnerModal: (state) => {
      state.isContactPartnerModalOpen = true;
    },
    closeContactPartnerModal: (state) => {
      state.isContactPartnerModalOpen = false;
      state.messageSent = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactPartnerSubmit.fulfilled, (state) => {
        state.messageSent = true;
      })
      .addCase(contactPartnerSubmit.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
        }
      });
  },
});

export interface RelatedProductClickPayload {
  code: number;
  href: string;
}

const actions = {
  ...reducerActions,
  contactSellerFieldValidationError: createAction<FieldValidationErrorPayload>(
    `${name}/invalidFieldError`,
  ),
  onPartnerStorefrontLinkClick: createAction<PartnerStorefrontLinkClickPayload>(
    `${name}/linkClick`,
  ),
  partnerProductCardsVisible: createAction<PartnerProductCardsVisiblePayload>(
    `${name}/partnerProductCardVisible`,
  ),
  onRelatedProductClick: createAction<RelatedProductClickPayload>(`${name}/relatedProductClick`),
};

export { actions, reducer };
